import { AuthEntrypoint } from './auth/AuthEntrypoint';
import { ThemeController } from './lib/theme';
import { RootRouter } from './routers/RootRouter';

export function App() {
  return (
    <>
      <ThemeController />
      <RootRouter authEntrypoint={<AuthEntrypoint />} />
    </>
  );
}
